import { render, staticRenderFns } from "./DataTablePanel.vue?vue&type=template&id=6c2829bf"
import script from "./DataTablePanel.vue?vue&type=script&lang=js"
export * from "./DataTablePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports